// format to norwegian format
export function formatPhoneNumber(phoneNumber: string): string {
  // Remove any non-digit characters from the input
  let cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

  // Ensure the phone number starts with 0047 or +47
  if (!cleanedPhoneNumber.startsWith('0047') && !cleanedPhoneNumber.startsWith('+47')) {
      cleanedPhoneNumber = '47' + cleanedPhoneNumber;
  }

  // Format the phone number as +47 XX XX XX XX
  return cleanedPhoneNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '+47 $2 $3 $4 $5');
}